/**
 * Acquisto periodico (Seal) nella pagina prodotto.
 * La pagina ha due widget Seal (desktop e mobile) fuori dal form del carrello:
 * il tema legge il primo input[name="selling_plan"], spesso quello del widget
 * nascosto e vuoto. Qui si copia il piano del widget visibile su tutti gli
 * input e si aggiorna il prezzo principale.
 */
(function () {
  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  function visibleWidget() {
    var inputs = document.querySelectorAll('input[data-sls-selling_plan][name="selling_plan"]');
    for (var i = 0; i < inputs.length; i++) {
      var box = inputs[i].closest('.sealsubs-target-element') || inputs[i].parentElement;
      if (isVisible(box)) return box;
    }
    return null;
  }

  var NUMBER = /\d[\d.,]*/;

  // Prezzo unitario dell'elemento: se il testo è cambiato da fuori (tema o Seal), quello nuovo diventa l'unitario.
  function unitText(el) {
    var current = el.textContent.trim();
    if (!el.hasAttribute('data-respet-original') || current !== el.getAttribute('data-respet-shown')) {
      el.setAttribute('data-respet-original', current);
    }
    return el.getAttribute('data-respet-original');
  }

  function show(el, text) {
    el.textContent = text;
    el.setAttribute('data-respet-shown', text);
  }

  function selectedPrice(widget) {
    var radio = widget.querySelector('input.sls-option:checked');
    var option = radio && radio.closest('.sls-option-container');
    var price = option && option.querySelector('.sls-total-price .sls-price');
    return price ? unitText(price) : '';
  }

  function parseAmount(str) {
    return Number(String(str).replace(/\./g, '').replace(',', '.')) || 0;
  }

  function formatAmount(n) {
    var parts = n.toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  // Con limiti MinMaxify (xo-min/xo-step > 1) il prezzo mostra il totale della quantità imposta.
  function quantityFactor() {
    var boxes = document.querySelectorAll('xo-cart-quantity[xo-min], xo-cart-quantity[xo-step]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.closest('xo-cart-mini') || box.closest('xo-cart') || !isVisible(box)) continue;
      var limited = Number(box.getAttribute('xo-min')) > 1 || Number(box.getAttribute('xo-step')) > 1;
      if (!limited) continue;
      var input = box.querySelector('input[name="quantity"]');
      return Math.max(1, Number(input && input.value) || 1);
    }
    return 1;
  }

  function scaled(original, base, factor) {
    if (!base || (factor === 1 && base === (original.match(NUMBER) || [])[0])) return original;
    return original.replace(NUMBER, formatAmount(parseAmount(base) * factor));
  }

  function updateSealPrices(factor) {
    document.querySelectorAll('.sealsubs-target-element .sls-price').forEach(function (el) {
      var original = unitText(el);
      show(el, scaled(original, (original.match(NUMBER) || [])[0], factor));
    });
  }

  function updatePrice(planId, sealPrice, factor) {
    var planAmount = planId ? (sealPrice.match(NUMBER) || [])[0] : '';
    document.querySelectorAll('.xo-product-info-content__price .xo-price__item[xo-price]').forEach(function (el) {
      var original = unitText(el);
      var isDel = el.classList.contains('xo-price__item--del');
      var base = !isDel && planAmount ? planAmount : (original.match(NUMBER) || [])[0];
      show(el, scaled(original, base, factor));
    });
  }

  function sync() {
    var factor = quantityFactor();
    var widget = visibleWidget();
    if (!widget) {
      updatePrice('', '', factor);
      return;
    }
    var own = widget.querySelector('input[data-sls-selling_plan][name="selling_plan"]');
    var planId = own ? own.value : '';
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      if (input !== own) input.value = planId;
    });
    var sealPrice = selectedPrice(widget);
    updateSealPrices(factor);
    updatePrice(planId, sealPrice, factor);
  }

  function syncSoon() {
    window.setTimeout(sync, 60);
    window.setTimeout(sync, 500);
    window.setTimeout(sync, 1500);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('xo-cart-add')) sync();
      else syncSoon();
    },
    true
  );
  document.addEventListener('change', syncSoon, true);
  document.addEventListener(
    'input',
    function (event) {
      if (event.target && event.target.name === 'quantity') syncSoon();
    },
    true
  );
  document.addEventListener('sealsubs:selling_plan_changed', syncSoon);
  window.addEventListener('load', syncSoon);
})();
